export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  primary: '#1C71E3',
  secondary: '#F5F5F5',
  navigationIcon: '#CAD6E5',
  danger: '#F44336',
  checkboxBackground: '#1890FF',
  mutedBlue: '#1F87C9',
  mutedBlueHover: '#1A6FA3',
  lightBorder: '#F0F0F0',
  darkBorder: '#303030',
  modalBackground: '#F5F6FA',
  modalBorder: '#E0E0E0',
  listBackground: '#CCD7DF',
  mutedGreen: '#2E7D32',
  lightCheckboxBorder: '#D9D9D9',
  lightColumnContainer: '#FAFAFA',
  darkColumnContainer: '#1D1D1D',
  altRowBackground: '#F5F6FF',
  dialogTrackBackground: '#F1F1F1',
  buttonHover: '#E8E8E8',
  navbarBorder: '#EEEEEE',
  cardBackground: '#FDFDFD',
  cardShadow: '#ECECEC',
};
